export const transfersTable = {
  header: 'All Transfers',
  created_at: 'Created Date',
  reference: 'Reference',
  status: 'Status',
  amount: 'Amount',
  source: 'Source',
  destination: 'Destination',
  attempt: 'Attempt #',
  maxAttempts: 'Max Attempts',

  search: 'Search Transfer ID',
};

export const transferDetails = {
  header1: 'Transfer',

  detailsHeader: 'Transfer Details',
  errorHeader: 'Error',
  attemptsHeader: 'Attemps',
  webhookHeader: 'Webhook Table',

  expectedArrival: 'Expected arrival: ',
  net: 'Net Value',

  created_at: 'Transaction Count',
  reference: 'Reference',
  integration: 'Integration',
  related: 'Related',
  source: 'Source',
  destination: transfersTable.destination,
  amount: transfersTable.amount,
  transferCode: 'Transfer Code',

  attempt: transfersTable.attempt,
  maxAttempts: transfersTable.maxAttempts,
  previousAttempt: 'Previous Attempt',
  nextAttempt: 'Next Attempt',
};
